/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { AiOutlineLock } from '@react-icons/all-files/ai/AiOutlineLock'
import { useNavigate, useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { setCredentials, encryptStorage } from '../slices/authSlice'
import { setNavigation } from '../slices/navigationSlice'
import axios from '../api/axios'
import Loading from '../components/Loading'
import useAxiosPrivate from '../hooks/useAxiosPrivate'

const LoginPage = () => {
	const [loading, setLoading] = useState(false)
	const navigate = useNavigate()
	const location = useLocation()
	const axiosPrivate = useAxiosPrivate()

	const { accessToken } = useSelector(state => state.auth)
	const dispatch = useDispatch()

	const from = location.state?.from?.pathname || '/'

	const {
		handleSubmit,
		register,
		formState: { errors }
	} = useForm({
		defaultValues: {
			username: ''
		}
	})

	useEffect(() => {
		if (accessToken) {
			navigate('/home', { replace: true })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const onSubmit = async formData => {
		setLoading(true)

		try {
			const { data } = await axios.post(
				'/account/loginWithAD?isFirst=true',
				{
					fullName: '',
					email: formData.username,
					email2: formData.username,
					uid: ''
				},
				{
					headers: {
						Authorization: `Bearer ${process.env.REACT_APP_AD_TOKEN}`
					}
				}
			)

			if (data.data.table[0].isAllowToSystem) {
				sessionStorage.setItem('fakeLogin', true)
				encryptStorage.setItem('znxpefwwcs', data.data.table[0])
				encryptStorage.setItem('rft', data.refreshToken)

				await dispatch(
					setCredentials({
						accessToken: data.accessToken,
						refreshToken: data.refreshToken,
						userInfo: data.data.table[0]
					})
				)

				const { data: navData } = await axiosPrivate.get(
					'/POP_Homepage/Get_MenuFrontEnd_List'
				)

				dispatch(setNavigation(navData.tb_menu_list_homepage))

				navigate(from, { replace: true })
			} else {
				toast.error('Not allowed to log in')
			}
		} catch (err) {
			toast.error(err.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
			{loading && <Loading />}

			<div className="login-page">
				<div className="login-logo">
					<img
						alt=""
						src={`${process.env.PUBLIC_URL}/images/logos/logo-one-platform.png`}
					/>
				</div>

				<form className="login-container" onSubmit={handleSubmit(onSubmit)}>
					<div className="login-box">
						<div>
							<label>Username</label>
							<input
								type="text"
								placeholder="Enter username"
								className={errors.username ? 'error' : ''}
								{...register('username', { required: 'Username is required' })}
							/>
							{errors.username && (
								<div className="error-message">{errors.username.message}</div>
							)}
						</div>
						{/* <div className="mt-3">
							<label>Password</label>
							<input
								type="password"
								placeholder="Enter password"
								className={errors.password ? 'error' : ''}
								{...register('password', { required: 'Password is required' })}
							/>
							{errors.password && (
								<div className="error-message">{errors.password.message}</div>
							)}
						</div> */}
					</div>

					<div className="flex flex-1 mt-5">
						<button
							className="flex-1 justify-center btn bg-white !mx-5 hover:bg-ci4 hover:text-white"
							type="submit"
						>
							<AiOutlineLock size={18} />
							<span className="ml-2">Login</span>
						</button>
					</div>

					{/* <div className="mt-5 text-center">
						<a
							className="text-black hover:text-white"
							onClick={() => navigate('/forgot-password')}
						>
							Forgot Password?
						</a>
					</div> */}

					{/* <div className="flex flex-1 mt-5">
						<button
							type="button"
							className="flex-1 justify-center btn border border-white text-white !mx-5 hover:border-ci1 hover:text-ci1"
							onClick={() => navigate('/register', { replace: true })}
						>
							Register a new account
						</button>
					</div> */}
				</form>
			</div>
		</>
	)
}

export default LoginPage
